/**
 * Created by Ning Jiang on 2021-05-28.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {DeadwoodRip} from "../../DeadwoodRip";
import {TimelineLite} from "gsap";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {IBaseSymbol} from "../../../core/symbol/BaseSymbol";

export class SymbolLandingController extends ReelStopPresentationController {

    private _animations:TimelineLite[] = [];

    constructor() {
        super("SymbolLandingController");
    }

    protected async onReelBounce(data:IReelStateEventData):Promise<any> {
        const promises:Promise<any>[] = [];
        const symbols:IBaseSymbol[] = [];
        DeadwoodRip.model.reels[data.reelId].forEach((symName, symIndex) => {
            if(DeadwoodRip.reels[data.reelId].isDataSymbolInValidArea(symIndex)) {
                const symbol = <IBaseSymbol>DeadwoodRip.reels[data.reelId].getSymbol(symIndex, true);
                if(symbol.playLanding && !symbols.includes(symbol)) {
                    if(symbol.reelId === 4 && !DeadwoodRip.model.parsedGameData.lastReelEnabled) {
                        return;
                    }
                    symbols.push(symbol);
                    const ani = symbol.playLanding(false);
                    this._animations.push(ani);
                    promises.push(Promise.resolve(ani).then(res => {
                        ArrayHelper.removeFirstMatchElement(this._animations, ani);
                    }));
                }
            }
        });
        await Promise.all(promises);
        symbols.length = 0;
    }

    public skip() {
        super.skip();
        this._animations.forEach(a => a.timeScale(2));
    }
}